import React from "react";
import { useOnScreen } from "hooks";
import { Header, Footer, FloatingActions } from "components";

export default function Layout({ layout2, children }) {
  const footerLogoReference = React.useRef(null);
  const isFooterLogoVisibleInViewPort = useOnScreen(footerLogoReference);

  return (
    <div id={`${!layout2 ? "layout" : "layout2"}`}>
      <Header />
      <main>{children}</main>
      <Footer footerLogoReference={footerLogoReference} />
      <FloatingActions reachedFooter={isFooterLogoVisibleInViewPort} />
    </div>
  );
}
